module.exports = __webpack_public_path__ + "img/marker-star-badge.966ac14b.svg";